module.exports = __webpack_public_path__ + "img/img_app_guide05.c0d703bf.png";